import * as moment from "moment";
import { rangeRight } from "lodash";
import { MONTHS_LONG } from "../../constants";
import { useRef, useState } from "react";

const FIRST_POSSIBLE_YEAR = 2019;

function getCommissionYears() {
  const currentYear = moment().year();
  return rangeRight(currentYear, FIRST_POSSIBLE_YEAR - 1);
}

// so we can still know the original number of the month after they've been reversed
const MONTHS_WITH_INDEX = MONTHS_LONG.map((m, i) => ({
  name: m,
  index: i,
}));

export function useCommissionMonths() {
  const years = useRef(getCommissionYears());
  const currentYear = moment().year();
  const [year, setYear] = useState(currentYear);

  const currentMonth = moment().month();
  let possibleMonths: typeof MONTHS_WITH_INDEX;
  if (year === currentYear) {
    possibleMonths = MONTHS_WITH_INDEX.slice(0, currentMonth + 1).reverse();
  } else {
    possibleMonths = MONTHS_WITH_INDEX.reverse();
  }

  return {
    years,
    year,
    setYear,
    possibleMonths,
  };
}



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/common.ts